<template>
   <div style="height: 90%;">
        <el-breadcrumb separator-class="el-icon-arrow-right">
             <el-breadcrumb-item @click.native="gohome" ><a>首页</a></el-breadcrumb-item>
          <el-breadcrumb-item>补充工伤保险办理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row type="flex"  align="middle" class="row-bg" justify="space-around" >
            <el-col :span="4"><div class="grid-content bg-purple-left" @click="ksbl('/changeRenewal')"><span class="span-style">月缴申报</span></div></el-col>
            <el-col :span="4"><div class="grid-content bg-purple-light" @click="ksbl('/jdjf')"><span class="span-style">季缴申报</span></div></el-col>
            <el-col :span="4"><div class="grid-content bg-purple-bn" @click="ksbl('/bnjf')"><span class="span-style">半年缴申报</span></div></el-col>
            <el-col :span="4"><div class="grid-content bg-purple" @click="ksbl('/yearpay')"><span class="span-style">年缴申报</span></div></el-col>
            <el-col :span="4"><div class="grid-content bg-purple-bjgwyf" @click="ksbl('/bjgwyf')"><span class="span-style">补缴过往月份</span></div></el-col>
          </el-row>
     </div>
 </template>

<script>
    export default {
        methods: {
            //返回首页
            gohome() {
                window.sessionStorage.setItem('activePath', "/welcome");
                this.$router.push("/welcome");
            },
            ksbl(urlpath) {
                this.$router.push(urlpath);
            }
        }
    }
</script>
<style lang="less" scoped>
    #card_st {
        width: 80%;
        margin: auto;
    }
</style>
<style scoped>
    .el-row {
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0;
        }
    }

    .span-style {
        color: rgb(253, 253, 253);
        font-size: 30px;
    }

    .el-col {
        border-radius: 4px;
    }

    .bg-purple-dark {
        background: #6595da;
    }

    .bg-purple {
        background: #53d1b2;
        height: 120px;
        line-height: 120px;
        text-align: center;
        overflow: hidden;
        cursor: pointer;
    }

    .bg-purple-left {
        background: #5190d8;
        height: 120px;
        line-height: 120px;
        text-align: center;
        overflow: hidden;
        cursor: pointer;
    }
    .bg-purple-bn {
        background: #a6df5d;
        height: 120px;
        line-height: 120px;
        text-align: center;
        overflow: hidden;
        cursor: pointer;
    }
    .bg-purple-light {
        background: #9845F7;
        height: 120px;
        line-height: 120px;
        text-align: center;
        overflow: hidden;
        cursor: pointer;
    }
    .bg-purple-bjgwyf {
      background: #40efd5;
      height: 120px;
      line-height: 120px;
      text-align: center;
      overflow: hidden;
      cursor: pointer;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }

    .row-bg {
        /* padding: 10px 0; */
        height: 60%;
    }
</style>
